module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/YE-b92597f5b31c0bc194684e80825e3998.png";